import React, { useEffect } from "react";
import {
    Link
} from "react-router-dom";

export default function Guides() {
    useEffect(() => {
        document.title = "Guides";
    }, []);

    const sections = [
        {
            title: "Chambers & Partners",
            groups: [
                {
                    heading: "Research",
                    links: [
                        { to: "/research", label: "Research Schedules" }
                    ]
                },
                {
                    heading: "Editorial",
                    links: [
                        { to: "/editorial", label: "Editorial History" }
                    ]
                },
                {
                    heading: "Ranking History",
                    links: [
                        { to: "/firms", label: "Firms Directory" },
                        { to: "/lawyers", label: "Lawyers Directory" }
                    ]
                },
                {
                    heading: "Archive",
                    links: [
                        { href: "/pdf/index.html", label: "Guide PDFs" },
                        { to: "/feedback", label: "Stored Guides" }
                    ]
                }
            ]
        },
        {
            title: "Legal 500",
            groups: [
                {
                    heading: "Ranking History",
                    links: [
                        { to: "/l500/firms", label: "Firms Directory" },
                        { to: "/l500/lawyers", label: "Lawyers Directory" }
                    ]
                }
            ]
        }
    ];

    return (
        <div className="container guides-page">
            <div className="body guides-body">
                <header className="guides-hero">
                    <p className="guides-eyebrow">Research Portal</p>
                    <h1>Guides and Directory Data</h1>
                    <p className="guides-intro">
                        Explore research schedules, ranking history, editorial records, and archives across Chambers and Legal 500.
                    </p>
                    <div className="portal-links-row portal-links-row--right">
                        <a className="guides-return-link report-request-link" href="mailto:mbuckley@gmail.com?subject=Portal%20Bug%20or%20Feature%20Request">Report a bug or request a feature</a>
                    </div>
                </header>

                <div className="guides-grid">
                    {sections.map((section) => (
                        <section key={section.title} className="guide-card" aria-label={section.title}>
                            <h2>{section.title}</h2>
                            <nav>
                                {section.groups.map((group) => (
                                    <div key={group.heading} className="guide-card-group">
                                        <h3>{group.heading}</h3>
                                        <ul>
                                            {group.links.map((item) => (
                                                <li key={item.label}>
                                                    {item.to ? <Link to={item.to}>{item.label}</Link> : <a href={item.href}>{item.label}</a>}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </nav>
                        </section>
                    ))}
                </div>
            </div>
        </div>
    );
}
